module.exports = __webpack_public_path__ + "static/image-350f0f2ab7d92ea56a5e7f188db34d26.jpg";